import { Navigate } from "react-router-dom";

const PrivateRoute = ({
  children,
  allowedRoles = [],
  allowUnapprovedUser = false,
  allowHrManagerUser = false,
}) => {
  const safeParse = (item) => {
    try {
      return JSON.parse(localStorage.getItem(item)) || {};
    } catch (e) {
      return {};
    }
  };

  const authState = safeParse("auth0-token-storage");
  const token = authState?.access_token;
  const userClaims = safeParse("user-claims");
  const isApprovedUser = userClaims?.isActive || false;
  // Check roles
  const userRoles = Array.isArray(userClaims.roles) ? userClaims.roles : [];
  const userHasRole = userRoles.some((role) =>
    allowedRoles.includes(role.name)
  );
  const isHrManagerRole = userRoles.some((a) => a.name === "hr-manager");

  // Check authentication
  if (!token || Object.keys(userClaims).length === 0) {
    return <Navigate to="/login" />;
  }

  // Check if user is approved, unless route allows unapproved users
  if (!isApprovedUser && !allowUnapprovedUser) {
    return <Navigate to="/unauthorized" />;
  }

  // Check if user is HR, unless route allows hr manager users
  if (isHrManagerRole && !allowHrManagerUser) {
    return <Navigate to="/unauthorized" />;
  }

  // If no roles are defined, allow any authenticated user
  if (allowedRoles.length === 0) {
    return children;
  }

  if (!userHasRole) {
    return <Navigate to="/unauthorized" />;
  }

  return children;
};

export default PrivateRoute;
